//basic
import React, { Component } from 'react';
import { toJS, computed } from 'mobx';
import { observer, inject } from 'mobx-react';

import Paper from '@material-ui/core/Paper';


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Search from '../../components/basic/search';
import CustomButton from '../../components/basic/CustomButton';

import AddEditPaymentType from '../shops/AddEditItem/AddEditItem';



import TableBodyRow from '../../components/basic/TableRow/TableBodyRow';
import TableHeadRow from '../../components/basic/TableRow/TableHeadRow';

// import '../../components/complex/customTable/index.scss'

//style
import './ExampleTable.css'
import './ExampleTable.scss'
import '../../screens/payments/index.scss'

//api
import { api } from '../../functions/api';

//custom components
import CustomTable3 from '../../components/complex/CustomTable3/CustomTable3';
// import Search from '../../../components/basic/search';
// import CustomButton from '../../../components/basic/CustomButton';



//material-ui
import { CircularProgress, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { mdiDotsVertical, mdiArrowDown,mdiCloudUpload, mdiCloudDownload, mdiCart,mdiPencil } from '@mdi/js'

//other libraries
import queryString from 'query-string';
import Icon from '@mdi/react';
import { mdiPlus } from '@mdi/js';

@inject('internal')
@inject('translate')
@observer
export default class ExampleTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            addEditDialog: false,
        }
    }
    
    dropDownMenuItems = [
        {
            title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
            action: "edit"
        },
        {
            title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
            action: "delete"
        },
    ]
   
    BodyValue = [
        {
            "title": "name",
        },
        {
            "title": "api_alias",
        },
        {
            "title": "url",
        },
    ];
    HeadValue = [
        {
            "title": "",
        },
        {
            "title": "Nazov",
            sortBy: "name"

        },
        {
            "title": "api",
        },
        {
            "title": "url",
            sortBy: "url"

        },
        {
            "title": "img",
        },
        {
            "title": "youtube",
        },
    ];
   
  
    componentDidMount() {

        if(toJS(this.props.internal.user)
            && toJS(this.props.internal.user.data)
            // && toJS(this.props.internal.user.data.permissions)
            // && toJS(this.props.internal.user.data.permissions.lists_payment_types)
            // && toJS(this.props.internal.user.data.permissions.lists_payment_types.view)
            )
            {

            this.loadShops();
            this.props.internal.setRoute(this.props.history, this.props.location.pathname);

            const URLqueryString = this.props.history.location.search
            let queries = queryString.parse(URLqueryString);

            let searchterm;
            if(queries) {
                if(queries.searchterm) {
                    searchterm = queries.searchterm
                    this.setState({searchTerm: searchterm})
                }
            }
        }
        else {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            // this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }
    
    
    renderData = []
    sortByBy = ""
    sortByDir= ""
    loadShops = async(size = 10, page = 0, searchterm = " ", by = "name", dir = "asc") => {


        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }
        }

        let params = {
            searchterm: searchterm,
            page: {
                number: page,
                size: size
            },
            order: [
                {
                    by: by,
                    dir: dir
                }
            ]
        }

        // this.setState({loadingPage: true})
        
        

        let load_data = await api({
            method:'get',
            url: 'lists/shops',
            authorization: this.props.internal.user.access_token,
            params: params,
            postman: true
        })
        if (load_data.success === true) {
            if (load_data.data) {
                this.props.internal.setDataForTable(load_data.data)

                const dataForTable = toJS(this.props.internal.dataForTable)
                this.sortByBy = this.props.internal.dataForTable.meta.order[0].by
                this.sortByDir = this.props.internal.dataForTable.meta.order[0].dir

    
    var result = [];
    var i;
    var resultData = []
    var j;
    var e;
    // for (i = 0; i < this.HeadValue.length; i++) {
        // result.push(<TableHeadRow key={i} >{this.HeadValue[i].title} </TableHeadRow>);
    //     result.push(<TableCell key={i} >{this.HeadValue[i].title} </TableCell>);
    // }

    
    
    for(j = 0; j < dataForTable.data.length; j++) {
        // resultData.push(<TableBodyRow key={j}>{dataForTable.data[j]}</TableBodyRow>)
let column = []
        // for(e = 0; e < dataForTable.data[j]; e++) {
            for(let e in dataForTable.data[j]){
                if (e === "iban") {
                    column.push(dataForTable.data[j][e])
                }else if(e === "street_name") {
                    column.push(dataForTable.data[j][e])
                }else if (e === "name") {
                    column.push(dataForTable.data[j][e])
                }else if (e === "our_story_image") {
                    column.push(<img className="imageTablewidth" src={`${dataForTable.data[j][e]}`}></img>)
                }else if (e === "youtube") {
                    column.push(<a href={`${dataForTable.data[j][e]}`}>{`${dataForTable.data[j][e]}`}</a>)
                }
            // resultData.push(<TableBodyRow key={e}>{dataForTable.data[e]}</TableBodyRow>)
    }
    resultData.push(<TableBodyRow dropDownMenuItems={this.dropDownMenuItems} data={column} ></TableBodyRow>)

}
            }
        }
    this.renderData = resultData

    this.setState({loadingPage: false})

    
    }

    myFunction = (inputText) => {
        alert("I am an alert box!" + inputText);

        
  }

  handleSort = (dir, orderBy) => {
    this.setState({
        loading: true
    })
    this.addQueryToUrl("dir", dir,"by", orderBy)
    // this.addQueryToUrl("by", orderBy)
}


  addQueryToUrl = (param, value, param2 = null, value2 = null) => {
    const URLqueryString = this.props.history.location.search
    let queries = queryString.parse(URLqueryString)
    queries[param] = value
    if(param2 && value2) {
        queries[param2] = value2
    }

    let new_path = this.props.location.pathname

    new_path += "?"
    for(let key in queries) {
        if(key && queries[key] !== "") {
            new_path += key + "=" + queries[key] + "&"
        }
    }
    new_path = new_path.slice(0,-1)

    this.props.internal.pushRoute(new_path)
    this.loadShops()
}

handleChangePage = (event, page) => {
    this.props.handleChangePage(page);
    //this.setState({ page: page });
};
handleChangeRowsPerPagee = (size) => {
    this.setState({
        loading: true
    });
    this.addQueryToUrl("page_size", size)
}
handleChangeRowsPerPage = event => {
    let numberOfRows;

    if(event.target.value === this.props.translate.i18n.GLOBAL.TABLE.ALL) {
        numberOfRows = Number(toJS(this.props.internal.dataForTable.meta.total))
        
    }
    else {
        numberOfRows = event.target.value
    }
    //this.setState({ rowsPerPage: event.target.value });
    

    this.handleChangeRowsPerPagee(numberOfRows);
    this.props.internal.administrators = [];
    
};
handleSearch = (searchTerm) => {

    if (searchTerm.length > 2) {
        this.addQueryToUrl("searchterm", searchTerm)
    }
    else  {
        this.addQueryToUrl("searchterm", "")
    }
}
createNewPaymentType = async () => {
    this.setState({openAddDialog: true})
}

 

    render () {
// const {dataForTable} = toJS(this.props.internal) keby bol objekt tak mozem pristupit
    
        return (
           this.state.loadingPage
           ?
           <CircularProgress className = {'circular-progress'}/>
           :
            <div className="payments-container">
            <AddEditPaymentType
                        open={this.state.openAddDialog}
                        title={this.props.translate.i18n.MODULES.PAYMENTS.NEW_PAYMENT_TYPE_TITLE}
                        onClose={this.closeDialog}
                    />
                <div className={'flex space-between'}>
                    <Search
                            placeholder={this.props.translate.i18n.MODULES.PAYMENTS.SEARCH}
                            classes={'products-search-box'} onChange={this.handleSearch}
                            value={this.state.searchTerm}/>

                    <CustomButton
                            mystyle={'btn-orange-bg border-radius-18'}
                            title={this.props.translate.i18n.MODULES.PAYMENTS.CREATE_NEW_PAYMENT_TYPE}
                            onClick={this.createNewPaymentType}
                            >
                        <Icon path={mdiPlus} size={1}/>
                    </CustomButton>
                </div>
                <Paper className={`table-box ${this.state.isIOS ? 'ios' : ''}`} >
                    <Table>
                        <TableHead >
                            <TableHeadRow   sortByBy = {this.sortByBy}
                                            sortByDir = {this.sortByDir}
                                            handleSort = {this.handleSort}
                                            parentFunction={this.myFunction}
                                            HeadValue={this.HeadValue}
                                            />
                        </TableHead>
                        <TableBody>
                            {/* {dataForTable.data.map((item, index) => (<TableBodyRow  dropDownMenuItems={this.dropDownMenuItems} BodyValue={this.BodyValue} item={item} key={index}/>))}  */}
                            {/* <TableBodyRow  column={this.column} />
                         */}
                         {this.renderData.map((item, index) => (item))}
                        </TableBody>
                    </Table>
                </Paper>
                <TablePagination
                    classes={{caption:"caption", selectIcon: "selectIcon", select: "selectPerPage"}}
                    component="div"
                    rowsPerPageOptions={[5,10,15,25,50, this.props.translate.i18n.GLOBAL.TABLE.ALL]}
                    className={'pagination'}
                    count={Number(toJS(this.props.internal.dataForTable.meta.total))}
                    rowsPerPage={Number(toJS(this.props.internal.dataForTable.meta.per_page))}
                    page={Number(toJS(this.props.internal.dataForTable.meta.current_page)) -1}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    labelDisplayedRows={({from, to, count}) => `${from}-${to} z ${count}`}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    labelRowsPerPage={this.props.translate.i18n.GLOBAL.TABLE.LABEL_ROWS_PER_PAGE}
                />
            </div>
        )
    }
}

{/* <Roew data={['asd', <div>asdasd</div>,]} /> */}




// WEBPACK FOOTER //
// ./src/screens/ExpaleTable/ExampleTable.jsx